if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.setupTimothyOptions(opener);
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }


      setupTimothyOptions(opener) {
        const source = opener.closest('modal-opener')?.querySelector('[data-tc-variants]');
        const custom = this.modalContent.querySelector('.custom-dropdown-wrapper');
        if (!source || !custom) return;
        const variants = JSON.parse(source.textContent);
        const controls = [...custom.querySelectorAll('.custom-option-control')];
        const nativePicker = this.modalContent.querySelector('variant-selects');
        const productForm = this.modalContent.querySelector('product-form');
        const form = productForm?.querySelector('form');
        const input = form?.querySelector('input[name="id"]');
        const submit = form?.querySelector('[type="submit"]');
        if (!form || !input || !submit || !controls.length) throw new Error('Quick buy form unavailable');

        const card = opener.closest('.card-wrapper');
        const header = document.createElement('div');
        header.className = 'tc-quick-summary';
        const photo = card?.querySelector('.card__media img');
        if (photo) { const img = photo.cloneNode(); img.width = 86; img.height = 120; img.loading = 'eager'; header.append(img); }
        const heading = document.createElement('h2');
        heading.textContent = card?.querySelector('.card__heading')?.textContent.trim() || '';
        header.append(heading);
        const title = this.modalContent.querySelector('.product__title');
        if (title) title.replaceWith(header); else custom.before(header);
        this.modalContent.querySelectorAll('.product__media-wrapper,.product__characteristics,.pd-shrt-desc').forEach(element => element.remove());
        const wrapper = document.createElement('div');
        wrapper.className = 'tc-quick-options';
        wrapper.dir = 'rtl';
        const selects = controls.map((control, index) => {
          const label = document.createElement('label');
          const text = document.createElement('span');
          text.textContent = control.dataset.optionName;
          const select = document.createElement('select');
          select.id = this.id + '-option-' + index;
          select.required = true;
          label.htmlFor = select.id;
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'בחרו ' + control.dataset.optionName;
          select.append(placeholder);
          [...new Set(variants.map(variant => variant.options[index]))].forEach(value => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            select.append(option);
          });
          label.append(text, select);
          wrapper.append(label);
          return select;
        });
        custom.replaceWith(wrapper);
        nativePicker?.remove();
        const price = submit.querySelector('.atc_price');
        const update = () => {
          const values = selects.map(select => select.value);
          const variant = values.every(Boolean) ? variants.find(item => item.options.every((value, index) => value === values[index])) : null;
          const valid = Boolean(variant?.available);
          input.value = valid ? String(variant.id) : '';
          input.disabled = !valid;
          submit.disabled = !valid;
          if (valid) submit.removeAttribute('aria-disabled');
          else submit.setAttribute('aria-disabled', 'true');
          if (price && variant) price.textContent = new Intl.NumberFormat('he-IL', {style:'currency', currency:'ILS'}).format(variant.price / 100);
          selects.forEach(select => select.removeAttribute('aria-invalid'));
          return valid;
        };
        selects.forEach(select => select.addEventListener('change', update));
        form.addEventListener('submit', event => {
          if (update()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const missing = selects.find(select => !select.value);
          if (missing) { missing.setAttribute('aria-invalid', 'true'); missing.focus(); }
        }, true);
        update();
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
